import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  Consequence_Bool_Exp,
  GetConsequenceCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetConsequenceCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type ConsequenceCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Consequence_Bool_Exp;
};

export const useGetConsequenceCount = createQueryHook<
  ConsequenceCountArgs,
  NavigationCounts,
  GetConsequenceCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    consequence_aggregate: { aggregate: toAggregate(data.consequence) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetConsequenceCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
